export enum FormControlHintType {
  MAX_LENGTH = 'maxLength',
  TEXT = 'text',
  TEMPLATE_REF = 'templateRef'
}
